import Axios from 'axios'
import { apiEnv } from '../index'

const apiStaging = 'https://staging.api.solease.nl'

const apiLive = 'https://api.solease.nl'

const getApi = () => apiEnv === 'LIVE' ? apiLive : apiStaging

const getRequest = (url: string, params: any, onSuccess: any, onError: any) => {
  Axios.get(getApi() + url, { params }).then(res => {
    onSuccess(res.data, res.status)
  }).catch(error => onError(error))
}

const putRequest = (url: string, params: any, onSuccess: any, onError: any) => {
  Axios.put(getApi() + url, { params }).then(res => {
    onSuccess(res.data, res.status)
  }).catch(error => onError(error))
}

const postRequest = (url: string, body: any, onSuccess: any, onError: any) => {
  Axios.post(getApi() + url, body).then(res => {
    onSuccess(res.data)
  }).catch(error => onError(error))
}

export { getRequest, postRequest, putRequest }
